import { createHttpEndpoint } from '../../utils'

import type { GetSellerFiles } from './files.d'

/**
 * Get the notifications for a given merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-file-library-api/definition#tag/Merchant-file-library-page/operation/get-bm-merchants-notifications}
 */
export const getSellerFiles = createHttpEndpoint<GetSellerFiles.Response>({
  method: 'GET',
  operationId: 'getSellerFiles',
  path: '/bm/merchants/notifications',
})

/**
 * Delete notifications for a given merchant.

 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-file-library-api/definition#tag/Merchant-file-library-page/operation/delete-bm-merchants-notifications}
 */
export const deleteSellerFiles = createHttpEndpoint({
  method: 'POST',
  operationId: 'deleteSellerFiles',
  path: '/bm/merchants/notifications/bulk/delete',
})
